import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { addToast } from 'containers/Toasts/actions'

import { FETCH_DMARC_INFO_REQUEST, SUBMIT_DMARC_INFO_REQUEST } from './constants'

const fetchDmarcInfoEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(FETCH_DMARC_INFO_REQUEST.INITIATE).mergeMap(() =>
    api.settings
      .getDmarcRequestInfo()
      .mergeMap((response) =>
        Observable.of(
          FETCH_DMARC_INFO_REQUEST.onSuccess({
            userRequestedDmarcInfo: response.dmarc_request_info,
          })
        )
      )
      .catch((error) => Observable.of(epicsErrorHandler(FETCH_DMARC_INFO_REQUEST.onError, error)))
  )

const submitDmarcInfoEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SUBMIT_DMARC_INFO_REQUEST.INITIATE).mergeMap(() =>
    api.settings
      .postDmarcRequestInfo()
      .mergeMap((response) =>
        Observable.of(
          SUBMIT_DMARC_INFO_REQUEST.onSuccess({
            userRequestedDmarcInfo: response.response.dmarc_request_info,
          }),
          addToast({
            message:
              'Your inquiry has been successfully submitted. Our team will reach out to you shortly.',
            type: 'success',
          })
        )
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(SUBMIT_DMARC_INFO_REQUEST.onError, error),
          addToast({
            message: error.response?.message || 'Failed to submit DMARC info request',
            type: 'error',
          })
        )
      )
  )

export default combineEpics(fetchDmarcInfoEpic, submitDmarcInfoEpic)
